var _mask, _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnion = function SvgUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 53,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Union_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 0C4.477 0 0 4.477 0 10v23c0 5.523 4.477 10 10 10h57.954l8.822 9.242a1 1 0 0 0 1.447 0L87.045 43H145c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#208339",
    fillRule: "evenodd",
    d: "M10 0C4.477 0 0 4.477 0 10v23c0 5.523 4.477 10 10 10h57.954l8.822 9.242a1 1 0 0 0 1.447 0L87.045 43H145c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.954 43 1.085-1.036-.443-.464h-.642zm8.822 9.242 1.086-1.035zm1.447 0-1.085-1.035zM87.045 43v-1.5h-.642l-.443.464zM1.5 10A8.5 8.5 0 0 1 10 1.5v-3C3.649-1.5-1.5 3.649-1.5 10zm0 23V10h-3v23zm8.5 8.5A8.5 8.5 0 0 1 1.5 33h-3c0 6.351 5.149 11.5 11.5 11.5zm57.954 0H10v3h57.954zm9.908 9.706-8.823-9.242-2.17 2.072 8.822 9.242zm-.724 0a.5.5 0 0 1 .724 0l-2.17 2.072a2.5 2.5 0 0 0 3.616 0zm8.822-9.242-8.822 9.243 2.17 2.07 8.822-9.241zM145 41.5H87.045v3H145zm8.5-8.5a8.5 8.5 0 0 1-8.5 8.5v3c6.351 0 11.5-5.149 11.5-11.5zm0-23v23h3V10zM145 1.5a8.5 8.5 0 0 1 8.5 8.5h3c0-6.351-5.149-11.5-11.5-11.5zm-135 0h135v-3H10z",
    mask: "url(#Union_svg__a)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: 28,
    fill: "#fff",
    fontFamily: "IBMPlexSans-Medium",
    fontSize: 18,
    textAnchor: "middle"
  }, "Get reimbursed")));
};
export default SvgUnion;